<script>
import List from './List.vue'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: List, // End of Component > extends
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        field: {
            type: Object,
            default() {
                let options=[]
                if(process.env.VUE_APP_COUNTRY == 'Pakistan')
                {
                    options=[
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                    ];
                }
                else
                {
                    options=[
                        {
                            text: 'National ID Card',
                            value: 'id',
                        },
                        {
                            text: 'Driving Licence',
                            value: 'licence',
                        },
                        {
                            text: 'Passport',
                            value: 'passport',
                        },
                    ];
                }
                return {
                    isRequired: true,
                    isLocked: true,
                    title: 'Select ID Document Type',
                    label: 'ID Document Type',
                    placeholder: 'Select ID Document Type',
                    options: options,
                }
            },
            required: true,
        },
    }, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */

    data() {
        return {
            textField: 'text',
            valueField: 'value',
            model: null,
            options: [],
        }
    },

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        this.options = this.field.options
    }, // End of Component > mounted
}
</script>
